module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "move"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    staticClass: "confirm"
  }, [_c('div', {
    staticClass: "confirm-view"
  }, [_c('div', {
    staticClass: "confirmtet"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("confirmorder")))])]), _vm._v(" "), _c('div', {
    staticClass: "confirmscrollbar"
  }, [_c('el-scrollbar', {
    staticStyle: {
      "height": "95%",
      "width": "90%",
      "margin": "auto"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.orderAddress,
      "rules": _vm.rules,
      "size": "mini",
      "show-message": false,
      "hide-required-asterisk": ""
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "label": _vm.$t('paymode')
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.state.orders.payMode),
      callback: function($$v) {
        _vm.$set(_vm.state.orders, "payMode", $$v)
      },
      expression: "state.orders.payMode"
    }
  }, [_c('el-radio-button', {
    staticClass: "confirmitme",
    attrs: {
      "label": _vm.$tc('paymodearray', 0)
    }
  }), _vm._v(" "), _c('el-radio-button', {
    staticClass: "confirmitme",
    attrs: {
      "label": _vm.$tc('paymodearray', 1)
    }
  }), _vm._v(" "), _c('el-radio-button', {
    staticClass: "confirmitme",
    attrs: {
      "label": _vm.$tc('paymodearray', 2)
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "resource"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.handleChange()
      }
    }
  }, [_c('el-container', [_c('el-aside', {
    attrs: {
      "width": "90%"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 23
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.orderAddress.Street) + " , " + _vm._s(_vm.orderAddress.City) + " , " + _vm._s(_vm.orderAddress.Province) + " , " + _vm._s(_vm.orderAddress.Zip))])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 23
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.orderAddress.CustomerName) + "  " + _vm._s(_vm.orderAddress.LinkmanPhone))])])], 1)], 1), _vm._v(" "), _c('el-main', [_c('i', {
    class: [_vm.isRotate ? 'el-collapse-item__arrow el-icon-arrow-right' : 'el-collapse-item__arrow el-icon-arrow-right is-active']
  })])], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    staticClass: "mb-1",
    attrs: {
      "label": _vm.$t('remark'),
      "prop": "desc"
    }
  }, [_c('el-input', {
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.state.orders.remark),
      callback: function($$v) {
        _vm.$set(_vm.state.orders, "remark", $$v)
      },
      expression: "state.orders.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "mb-1",
    attrs: {
      "label": _vm.$t('delivery')
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("numFilter")(_vm.state.orders.deliveryPrice)) + " €")])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "mb-1",
    attrs: {
      "label": _vm.$t('subtotal')
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm._f("numFilter")(_vm.state.orders.totalPrice)) + " €")])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "mb-1",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "label": _vm.$t('total')
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm._f("numFilter")((_vm.state.orders.deliveryPrice + _vm.state.orders.totalPrice))) + " €")])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "confirmprimary",
    on: {
      "click": function($event) {
        _vm.submitForm('ruleForm')
      }
    }
  }, [_c('span', {
    staticClass: "pay"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t("sumbitorder")) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "confirm-close",
    on: {
      "click": _vm.hide
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-bottom"
    }
  }, [_vm._v(" -->\n        "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show2),
      expression: "show2"
    }],
    staticClass: "transition-box"
  }, [_c('el-scrollbar', {
    staticStyle: {
      "height": "95%",
      "width": "90%",
      "margin": "auto"
    }
  }, [_c('div', {
    staticClass: "rating-wrapper"
  }, [_c('ul', [_vm._l((_vm.myaddresseditlist), function(item, index) {
    return _c('li', {
      staticClass: "rating-item",
      on: {
        "click": function($event) {
          _vm.selectFood(index, item, $event)
        }
      }
    }, [_c('div', {
      staticClass: "myaddresscontent"
    }, [_c('h1', {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t('name')) + ":" + _vm._s(item.CustomerName) + "  ")]), _vm._v(" "), _c('div', {
      staticClass: "star-wrapper"
    }, [_c('span', {
      staticClass: "delivery"
    }, [_vm._v(_vm._s(item.Street) + " , " + _vm._s(item.City))])]), _vm._v(" "), _c('div', {
      staticClass: "star-wrapper"
    }, [_c('span', {
      staticClass: "delivery"
    }, [_vm._v(_vm._s(item.Province) + " , " + _vm._s(item.Zip))])]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v("\n                            " + _vm._s(_vm.$t('phone')) + " : " + _vm._s(item.LinkmanPhone) + "\n                              ")]), _vm._v(" "), _c('div', {
      staticClass: "defaultaddress"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.state.defaultaddress),
        expression: "state.defaultaddress"
      }],
      staticClass: "checkbtn",
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": index,
        "checked": _vm._q(_vm.state.defaultaddress, index)
      },
      on: {
        "change": function($event) {
          _vm.$set(_vm.state, "defaultaddress", index)
        }
      }
    })])])])
  }), _vm._v(" "), _c('li', {
    staticClass: "rating-item",
    on: {
      "click": function($event) {
        _vm.addAddress($event)
      }
    }
  }, [_c('div', {
    staticClass: "myaddresscontent"
  }, [_c('div', {
    staticClass: "add-address"
  }, [_c('i', {
    staticClass: "icon-add_circle",
    staticStyle: {
      "color": "#00b43c"
    }
  })])])])], 2)])])], 1)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9273eb8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/complete/confirm.vue
// module id = 483
// module chunks = 1